import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/service-worker.js').catch((error) => {
			console.error('Service-Worker-Registrierung fehlgeschlagen:', error);
		});
	});
	// Temporaeres Debugging fuer Push-Fokus-Erkennung: Der Service Worker schickt
	// bei jedem Push eine Nachricht mit dem erkannten Fokus-Zustand, die hier ohne
	// DevTools-Fokusverlust im localStorage protokolliert wird.
	navigator.serviceWorker.addEventListener('message', (event) => {
		if (event.data && event.data.type === 'push-debug') {
			const log = JSON.parse(localStorage.getItem('push-debug-log') || '[]');
			log.push(event.data.debugInfo);
			localStorage.setItem('push-debug-log', JSON.stringify(log.slice(-20)));
		}
	});
}

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
      <App key="webapp">
      </App>
  </React.StrictMode>
);

